import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { VppApplicationsRequestService } from './vpp-applications-request-service';
import { VppApplicationsEffects } from './vpp-applications.effects';
import { VppApplicationsReducer } from './vpp-applications.reducer';

export const provideVppApplicationsStore = () => [
  provideState('vppApplications', VppApplicationsReducer),
  provideEffects([VppApplicationsEffects]),
  VppApplicationsRequestService,
];
